export class MagnetoGetConfigNotification {
    public Expiration: Date;
    public TypeCode: number;
    public WasSuccess: boolean;
    public UId: string;
    public ErrorCode: string;
    public MessageIdIfResultOfUserRequest: string;
    public Body: string;
    constructor(json: object = null) {
        if (json) {
            Object.assign(this, json);

            this.Expiration = new Date(json['Expiration']);
        }
    }
}
